<template>
    <div class="p-generate-schedule">
        <router-view></router-view>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import DocumentEditor from 'components/documents//DocumentEditor.vue';
    import store from 'store/index';

    export default {
        name: 'documents',
        components: {
            DocumentEditor
        },
        computed: {
            ...mapGetters('claim', {
                claimId: 'id',
                claimType: 'type'
            }),
            ...mapGetters('http', [
                'running',
                'apiRouteRequestRunning'
            ]),
        },
        methods: {
        }
    }
</script>



// WEBPACK FOOTER //
// Documents.vue?72882925